import React, { useEffect, useState, useRef } from "react"
import { PiPrinter } from "react-icons/pi"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { printCart } from "utils"
import { IconButton } from "components"
import classes from "./OfflineOrderDetailsPrintButton.module.scss"

const OfflineOrderDetailsPrintButton = props => {
  const { offlineOrder } = props

  const [t, i18n] = useTranslation()

  const [loading, setLoading] = useState(false)

  const unmount = useRef(false)

  const handlePrintOrder = async () => {
    setLoading(true)

    await printCart(offlineOrder)

    if (unmount.current) return

    setLoading(false)
  }

  useEffect(() => {
    return () => unmount.current = true
  }, [])

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div
      className={classes["container"]}
      onClick={handlePrintOrder}
    >
      <IconButton
        color="black"
        loadingColor="black"
        icon={PiPrinter}
        loading={loading}
        size={18}
      />
      <span
        className={clsx(
          classes["text"],
          isLtr && classes["text-ltr"]
        )}
      >
        {t("پرینت_حرارتی_رسید")}
      </span>
    </div>
  )
}

export default OfflineOrderDetailsPrintButton